import { useCallback, useState } from 'react';

import { AnalyticalVariableListItem } from '@verantos-dev/feature-analytical-variables';

export const useAvLibraryPage = () => {
  const [selectedAv, setSelectedAv] = useState<AnalyticalVariableListItem | null>(null);

  const handleNameClick = useCallback((analyticalVariable: AnalyticalVariableListItem) => {
    setSelectedAv(analyticalVariable);
  }, []);

  const handleCloseDetail = useCallback(() => {
    setSelectedAv(null);
  }, []);

  return { selectedAv, handleNameClick, handleCloseDetail };
};
